<template>
  <div :style="{'text-align': imgAlign}">
    <img :style="{'width': imgWidth, 'margin-top': imgMt}" :src="imgSrc" />
  </div>
</template>
<script>
export default {
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    imgWidth: {
      type: String
    },
    imgMt: {
      type: String
    },
    imgAlign: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
div {
  img {
    resize: both;
  }
}
</style>
